import DeviceDetect from 'mobile-detect';

const DeviceDetail = new DeviceDetect(navigator.userAgent);

class OrientationUtils {
  getOrientation() {
    if (DeviceDetail.tablet()) {
      if (window.orientation === 0 || window.orientation === 180) {
        return true;
      } else {
        return false;
      }
    } else if (DeviceDetail.mobile()) {
      if (window.orientation === 90 || window.orientation === -90) {
        return true;
      } else {
        return false;
      }
    }
  }

  getDevice() {
    if (DeviceDetail.tablet()) {
      return 'tablet';
    } else if (DeviceDetail.mobile()) {
      return 'mobile';
    } else {
      return null;
    }
  }
}

export default new OrientationUtils();
